import React, { useState, useEffect, useContext } from "react";
import "./sectionSchedule.scss";
import ArrowButton from "../../atoms/arrow-button/arrowButton";
import SeccionTitle from "../../atoms/seccion-title/seccionTitle";
import { getAllResources } from "../../../services/scheduling";
import { getAvailabilitySpecialist } from "../../../services/scheduling";
import Summary from "../../molecules/summary/summary";
import OtherSpecialist from "../../molecules/others-specialist/otherSpecialist";
import Calendar from "../../atoms/calendar/calendar";
import AvailableHours from "../../atoms/available-hours/availableHours";
import { HrFormat } from "../../../utils/TimeFormatToHr";
import Loading from "../../atoms/loading/loading";
import GlobalContext from "../../../contexts/globalContext";
import BreadcrumbScheduling from "../../atoms/breadcrumb-scheduling/breadcrumb-scheduling";

interface SectionScheduleInterface {
  setnextPage?: any;
  setpageAtive?: any;
  selectSpecialist?: any;
  selectCategory?: any;
  pageAtive?: any;
  setselectSpecialist?: any;
  content?: any;
  beforePage: string;
  setcardActvie?: any;
  setconfirmationDate: any;
  nameCategory?: any;
}

const sectionSchedule = (props: SectionScheduleInterface) => {
  const {
    setnextPage,
    setpageAtive,
    selectSpecialist,
    selectCategory,
    setselectSpecialist,
    content,
    beforePage,
    setconfirmationDate,
  } = props;
  const [allSpecialist, setallSpecialist] = useState<any>([]);
  const [date, setdate] = useState("");
  const [specialistSchedule, setspecialistSchedule] = useState<any>([]);
  const [hour, sethour] = useState("");
  const defaultDate = new Date();
  const [actualYear, setactualYear] = useState(defaultDate.getFullYear());
  const [actualMonth, setActualMonth] = useState(defaultDate.getMonth() + 1);
  const [buttonActive, setbuttonActive] = useState("");
  const [loading, setloading] = useState(false);
  const contextValue = useContext(GlobalContext);

  useEffect(() => {
    setnextPage("Resumen");
    getSpecialist();
  }, []);

  const getSpecialist = async () => {
    try {
      setloading(true);
      const specialist = await getAllResources(
        contextValue.userInfoContext.data?.userJwt,
        selectCategory.resourcesIds,
        selectCategory.id
      );
      setallSpecialist(specialist.data.data.body.data);
      setloading(false);
    } catch (error) {
      setloading(false);
    }
  };

  const getAvailableSpecialist = async () => {
    try {
      const schedule = await getAvailabilitySpecialist(
        contextValue.userInfoContext.data?.userJwt,
        selectSpecialist.service.id,
        selectSpecialist.id,
        actualYear,
        actualMonth
      );
      
      setspecialistSchedule(schedule.data.data.body);
    } catch (error) {
      // setloading(false)
    }
  };

  const appoinmentData = () => {
    if (buttonActive) {
      const data = {
        customer: {
          companyName: "Pragma",
          email: contextValue.gigyaContext.gigyaAccount?.profile.email,
          firsName: contextValue.gigyaContext.gigyaAccount?.profile.firstName,
          lastName: contextValue.gigyaContext.gigyaAccount?.profile.lastName,
          mobilePhone: parseInt(
            contextValue.gigyaContext.gigyaAccount?.data.mobile
              ? contextValue.gigyaContext.gigyaAccount?.data.mobile
              : "0000000"
          ),
        },
        dateTime: `${date} ${HrFormat(buttonActive)}`,
        resource: {
          email: selectSpecialist.email,
          id: selectSpecialist.id,
          name: selectSpecialist.name,
        },
        service: {
          id: selectSpecialist.service.id,
          name: selectSpecialist.service.name,
          duration: selectSpecialist.service.duration,
        },
      };
      setconfirmationDate(data);

      setpageAtive(4);
    }
  };

  useEffect(() => {
    getAvailableSpecialist();
  }, [actualMonth, selectSpecialist, actualYear]);

  useEffect(() => {
    const el = document.getElementsByTagName('style')

    if (el.length > 0) {
      for (let i = 0; i < el.length; i++) {
        if (el[i].innerText.includes('gigya-screen-caption')) {
          el[i].parentNode?.removeChild(el[i])
        }        
      }        
    }
  })

  return (
    <>
      <div className="o-schedule-breadcrumb">
        <BreadcrumbScheduling
          content={`Agendamiento / ${selectCategory.name} / Horario`}
        />
        <div className="o-schedule">
          <div className="o-schedule__content__left ">
            <SeccionTitle
              title={content.tituloBanner}
              description={content.tituloDescripcion}
            />

            <div className="hide-on-mobile">
              <Summary
                selectSpecialist={selectSpecialist}
                dateAndTime={`${date ? date : ""} ${
                  buttonActive ? HrFormat(buttonActive) : ""
                }`}
              />
            </div>
          </div>
          <div className="o-schedule__content__right">
            <div>
              {loading ? (
                <Loading />
              ) : (
                <>
                  {specialistSchedule.data ? (
                    <div className="o-schedule__content__right__calendar">
                      <Calendar
                        setdate={setdate}
                        event={specialistSchedule}
                        sethour={sethour}
                        setactualYear={setactualYear}
                        setactualMonth={setActualMonth}
                        specialistName={selectSpecialist.service.name}
                        setHoursEmpty={setbuttonActive}
                      />
                      <AvailableHours
                        date={date}
                        data={hour}
                        setbuttonActive={setbuttonActive}
                        buttonActive={buttonActive}
                      />
                    </div>
                  ) : (
                    ""
                  )}
                </>
              )}
            </div>
            <div className="o-schedule__content__left show-on-mobile">
              <Summary
                selectSpecialist={selectSpecialist}
                dateAndTime={`${date ? date : ""} ${
                  buttonActive ? HrFormat(buttonActive) : ""
                }`}
              />
            </div>
            <div className="o-schedule__content__right__others">
              {allSpecialist.length > 1 ? (
                <OtherSpecialist
                  allSpecialist={allSpecialist}
                  selectSpecialist={selectSpecialist}
                  pageActive={setpageAtive}
                  setSelectSpecialist={setselectSpecialist}
                  setdate={setdate}
                  sethour={sethour}
                />
              ) : (
                ""
              )}
            </div>
          </div>
        </div>
        <div className="o-schedule__footer">
          <ArrowButton
            text={beforePage}
            way={"left"}
            onAction={() => {
              setselectSpecialist("Fecha y Hora");
              setpageAtive(2)
            }}
            gtmMark={
              "gtmRedDeAmorSesionIniciadaAgendarServicioCategoriaSiguienteResumen"
            }
          />
          <ArrowButton
            text="Confirmar Cita"
            way={"right"}
            onAction={() => appoinmentData()}
            gtmMark={
              "gtmRedDeAmorSesionIniciadaAgendarServicioCategoriaAnteriorEspecialista"
            }
          />
        </div>
      </div>
    </>
  );
};

export default sectionSchedule;
